import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "./HealthcareProductsSub.css";

import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../utils/common";

export default function HealthcareProductsSub({ banners = [] }) {
  const navigate = useNavigate();

  return (
    <section className="product-slider-wrapper">
      <div className="container">
        <div className="section-heading">
          <h2 className="section-heading__title">
            Shop Top <span>Healthcare</span> Products
          </h2>
          <p className="section-heading__sub">
            Trusted care for you and your family, at special prices
          </p>
        </div>

        {banners.length > 0 && (
          <Swiper
            className="healthcare-products-swiper"
            modules={[Autoplay]}
            spaceBetween={24}
            slidesPerView={3}
            autoplay={{
              delay: 3200,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={banners.length > 3}
            speed={850}
            grabCursor
            breakpoints={{
              320: { slidesPerView: 1.3, spaceBetween: 12 },
              576: { slidesPerView: 2, spaceBetween: 16 },
              768: { slidesPerView: 2.5, spaceBetween: 20 },
              992: { slidesPerView: 3, spaceBetween: 24 },
            }}
          >
            {banners.map((item, index) => (
              <SwiperSlide key={item.id ?? item.product_id ?? index}>
                <article className="product-card">
                  <div className="product-image">
                    <div className="product-image__circle">
                      <img
                        src={process.env.REACT_APP_IMG_URL + item.image}
                        alt={item.name || "Healthcare product"}
                        loading="lazy"
                      />
                    </div>

                    {item.discount && (
                      <span className="product-card__discount">
                        {item.discount}
                      </span>
                    )}
                  </div>

                  <h3 className="product-card__title">
                    {item.name || "Healthcare Essentials"}
                  </h3>

                  <p className="product-card__description">
                    {item.description ||
                      "Quality care for your everyday wellness needs."}
                  </p>

                  <div className="product-card__action">
                    <Green_btn
                      btnText="Shop Now"
                      onClick={() => {
                        if (item?.product_id) {
                          navigate(
                            `/product-details/${encodeId(item.product_id)}`,
                          );
                        }
                      }}
                    />
                  </div>
                </article>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </section>
  );
}